// NPM
import React from 'react';
import { Button, PRIMARY, TERTIARY } from '@glu/buttons-react';
import PropTypes from 'prop-types';
import { JSSClasses } from '../../proptypes/jss-prop-types';
import { challengeTypes } from '../../constants';
// Components
import Input from '../gluValidation/Input';
import Checkbox from '../checkbox/Checkbox';

const RADIUS = ({
  classes,
  data,
  deviceChallenge,
  isSubmitting,
  locale,
  onCancel,
  onChange,
  onChecked,
  onKeyDown,
  onSubmitForm,
  radiusToken,
  rememberMeFlag,
  validate
}) => {
  const { challengeFirstAttempt, challengeType = '' } = data;
  const type = challengeType.toUpperCase();
  const { RADIUS_UNAVAILABLE } = challengeTypes;

  return (
    <>
      <div>
        <div className="modal-header">{locale['challengeManager.title']}</div>
        {type !== RADIUS_UNAVAILABLE && (
          <div className="text">{locale['challengeManager.enterPinTokenCode']} </div>
        )}
      </div>
      <div className={`${classes.inputSection} ${classes.centerContent}`}>
        <div className={classes.inputField}>
          {type !== RADIUS_UNAVAILABLE && (
            <Input
              disabled={isSubmitting}
              autoCorrect="off"
              className="form-group"
              data-qa="radius-token"
              id="radius-token"
              label={locale['challengeManager.pinTokenCode']}
              name="token1"
              type="text"
              onChange={onChange}
              validators={[{ required: true, msg: locale['validation.required'] }]}
              onKeyDown={onKeyDown}
            />
          )}
          <span className={classes.error} data-testid="error-content">
            {type === RADIUS_UNAVAILABLE && locale['challengeManager.radiusUnavailable']}
            {type !== RADIUS_UNAVAILABLE &&
              !challengeFirstAttempt &&
              locale['common.invalidEntry']}
          </span>
        </div>
      </div>
      {deviceChallenge && type !== RADIUS_UNAVAILABLE && (
        <div className={`${classes.rememberMe}`}>
          <label htmlFor="rememberMe">
            <Checkbox
              onChange={(e) => onChecked(e.target.checked)}
              checked={rememberMeFlag}
              name="rememberMe"
              id="rememberMe"
              data-qa="rememberMe"
            />
            <span className="bold">{locale['challengeManager.rememberDevice']}</span>
          </label>
        </div>
      )}
      <section>
        {type !== RADIUS_UNAVAILABLE && (
          <Button
            className="btn btn-primary"
            data-qa="modal-notification-primary-btn"
            text={isSubmitting ? locale['common.submittingPleaseWait'] : locale['common.continue']}
            disabled={!radiusToken || isSubmitting}
            variant={PRIMARY}
            onClick={async (e) => {
              const { isValid } = await validate();
              if (isValid) onSubmitForm(e);
            }}
            data-testid="continueButton"
          />
        )}
        <Button
          className="btn btn-tertiary"
          onClick={onCancel}
          data-qa="modal-notification-secondary-btn"
          text={locale['common.cancel']}
          variant={TERTIARY}
          data-testid="cancelButton"
        />
      </section>
    </>
  );
};

RADIUS.propTypes = {
  locale: PropTypes.shape({}).isRequired,
  classes: JSSClasses.isRequired,
  data: PropTypes.shape({}).isRequired,
  deviceChallenge: PropTypes.bool,
  isSubmitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  radiusToken: PropTypes.string,
  validate: PropTypes.func.isRequired
};

RADIUS.defaultProps = {
  radiusToken: '',
  deviceChallenge: false
};

export default RADIUS;
